/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useRef, useState } from "react";
import { DataTable, DataTableSortEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import Loader from "../../../components/loader";
import PrimePaginator from "../../../components/prime-paginator";
import DeleteConfirmationDialog from "../../../components/delete-confirmation";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { ConfirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import {
    checkActionAuthorization,
    downloadCsvFile,
    IsFormValid,
} from "../../../service/shared.service";
import {
    IsNullOrEmptyArray,
    IsNullOrUndefined,
    IsStringNullEmptyOrUndefined,
} from "../../../utils/null-check";
import { toastOptObj } from "../../../utils/constants";
import { APIResponseEntity } from "../../../interface/api-responce";
import { PaginateRespEntity } from "../../../interface";
import { AxiosResponse } from "axios";
import {
    APIToGetWorkCenter,
    APIToCreateWorkCenter,
    APIToUpdateWorkCenter,
    APIToDeleteWorkCenter,
    APIToExportWorkCenter,
    APIToGetWorkCenterDDL,
} from "../../../service/api-service";
import { DropdownOption, WorkCenterDetailsEntity, WorkCenterFilterRequest } from "../../../interface/production-master";
import { MultiSelect } from "primereact/multiselect";
const Status = [
    { name: "Active", code: true },
    { name: "Inactive", code: false },
];

function WorkCenter() {
    const [status] = useState(["Active", "Inactive"]);
    const [selectedStatus, setSelectedStatus] = useState(""); const [isLoading, setIsLoading] = useState<boolean>(false);
    const [workCenterDetails, setWorkCenterDetails] = useState<WorkCenterDetailsEntity[]>([]); const [totalPageCount, setTotalPageCount] = useState<number>(0);
    const [selectedMasterFilters, setSelectedMasterFilters] = useState<string[]>([]);
    const [tempMasterFilters, setTempMasterFilters] = useState<string[]>([]);
    const masterFilterRef = useRef<any>(null);
    const [filterReq, setFilterReq] = useState<WorkCenterFilterRequest>({
        pageSize: 10,
        pageNumber: 0,
        sortColumn: "createdAt",
        sortOrder: "desc",
        codesearchText: "",
        fullNamesearchText: "",
        masterTrackerIds: [],
        status: "",
        APICallCount: 0,
    });
    const [isDeleteRecordId, setIsDeleteRecordId] = useState<string>("");
    const [isWorkCenterDialogVisible, setIsWorkCenterDialogVisible] = useState<boolean>(false);
    const [isEditMode, setIsEditMode] = useState<boolean>(false);
    const [selectedWorkCenterId, setSelectedWorkCenterId] = useState<string>("");
    const [workCenterCode, setWorkCenterCode] = useState<string>("");
    const [workCenterName, setWorkCenterName] = useState<string>("");
    const [selectedMasterTrackId, setSelectedMasterTrackId] = useState<string[]>([]);
    const [tempMasterTrack, setTempMasterTrack] = useState<string[]>([]);
    const masterTrackMultiSelectRef = useRef<any>(null);
    const [selectedDepartmentId, setSelectedDepartmentId] = useState<string>("");
    const [workCenterIsActive, setWorkCenterIsActive] = useState<boolean>(true);
    const [isDynamicJob, setIsDynamicJob] = useState<boolean>(false);
    const [workCenterDay, setWorkCenterDay] = useState<string>("");
    const [submitted, setSubmitted] = useState<boolean>(false);
    const [formErrors, setFormErrors] = useState({
        code: "Please enter code",
        name: "Please enter name",
        masterTrack: "Please select master track",
        department: "Please select department",
        day: "Please enter day",
    });
    const [masterTrackOptions, setMasterTrackOptions] = useState<DropdownOption[]>([]);
    const [departmentOptions, setDepartmentOptions] = useState<DropdownOption[]>([]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(async () => {
            await fetchWorkCenters();
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [filterReq]);

    useEffect(() => {
        fetchDropdownOptions();
    }, []);
    const fetchWorkCenters = async (): Promise<void> => {
        setIsLoading(true);
        const reqObj = {
            pageNumber: filterReq.pageNumber,
            pageSize: filterReq.pageSize,
            sortOrder: filterReq.sortOrder,
            sortColumn: filterReq.sortColumn,
            codesearchText: filterReq.codesearchText,
            fullNamesearchText: filterReq.fullNamesearchText,
            masterTrackerIds: filterReq.masterTrackerIds,
            ...(!IsStringNullEmptyOrUndefined(filterReq.status) && {
                status: filterReq.status,
            }),
        };
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToGetWorkCenter(reqObj);
            setWorkCenterDetails([]);
            setTotalPageCount(0);
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const paginateResp: PaginateRespEntity = axiosResp.data;
                    setWorkCenterDetails(paginateResp.data);
                    setTotalPageCount(paginateResp.totalCount);
                } else {
                    toast.error(axiosResp?.message || "Unable to get work centers", { ...toastOptObj, });
                }
            } else {
                toast.error(resp?.data?.message || "Unable to get work centers", { ...toastOptObj, });
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    const fetchDropdownOptions = async (): Promise<void> => {
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToGetWorkCenterDDL();

            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;

                if (axiosResp && axiosResp.data && axiosResp.statusCode === 200) {
                    setDepartmentOptions(
                        (axiosResp.data.department || []).map(
                            (item: any) => ({
                                label: item.displayName,
                                value: item._id,
                            })
                        )
                    );
                    setMasterTrackOptions(
                        (axiosResp.data.masterTracker || []).map(
                            (item: any) => ({
                                label: item.code,
                                value: item._id,
                            })
                        )
                    );
                }
            }
        } catch (error) {
            toast.error("Unable to get dropdown options", { ...toastOptObj, });
        }
    };

    const onPageChange = (event: PaginatorPageChangeEvent): void => {
        setFilterReq(prev => ({
            ...prev,
            pageSize: event.rows,
            pageNumber: event.page,
            APICallCount: prev.APICallCount + 1,
        }));
    };

    const onTableSort = (event: DataTableSortEvent): void => {
        if (event && event.sortField && event.sortOrder) {
            setFilterReq(prev => ({
                ...prev,
                sortColumn: event.sortField as string,
                sortOrder: event.sortOrder === 1 ? "asce" : "desc",
                pageNumber: 0,
                APICallCount: prev.APICallCount + 1,
            }));
        }
    };

    const handleAdd = async (): Promise<void> => {
        setIsEditMode(false);
        setIsDynamicJob(false);
        setSelectedWorkCenterId("");
        setWorkCenterCode("");
        setWorkCenterName("");
        setSelectedMasterTrackId([]);
        setTempMasterTrack([]);
        setSelectedDepartmentId("");
        setWorkCenterDay("");
        setWorkCenterIsActive(true);
        setSubmitted(false);
        setFormErrors({
            code: "Please enter code",
            name: "Please enter name",
            masterTrack: "Please select master track",
            department: "Please select department",
            day: "Please enter day",
        });
        await fetchDropdownOptions();
        setIsWorkCenterDialogVisible(true);
    };

    const handleEdit = async (rowData: WorkCenterDetailsEntity): Promise<void> => {
        if (!rowData || IsStringNullEmptyOrUndefined(rowData.id)) {
            return;
        }
        await fetchDropdownOptions();
        const masterTrackId = Array.isArray(rowData.masterTrackerId) ? rowData.masterTrackerId : (rowData.masterTrackerId ? [rowData.masterTrackerId] : []);
        const deptId = rowData.departmentId || "";

        setSelectedWorkCenterId(rowData.id);
        setWorkCenterCode(rowData.code || "");
        setWorkCenterName(rowData.fullName || "");
        setSelectedMasterTrackId(masterTrackId);
        setTempMasterTrack(masterTrackId);
        setSelectedDepartmentId(deptId);
        setWorkCenterDay(IsNullOrUndefined(rowData.day) ? "" : String(rowData.day));
        setWorkCenterIsActive(rowData.isActive ?? true);
        setIsDynamicJob(rowData.isDynamicJob ?? false);
        setIsEditMode(true);
        setSubmitted(false);
        setFormErrors({
            code: "",
            name: "",
            masterTrack: masterTrackId.length > 0 ? "" : "Please select master track",
            department: deptId ? "" : "Please select department",
            day: IsNullOrUndefined(rowData.day) ? "Please enter day" : "",
        });
        setIsWorkCenterDialogVisible(true);
    };
    const closeWorkCenterDialog = (): void => {
        setIsWorkCenterDialogVisible(false);
        setIsDynamicJob(false);
        setIsEditMode(false);
        setSelectedWorkCenterId("");
        setWorkCenterCode("");
        setWorkCenterName("");
        setSelectedMasterTrackId([]);
        setTempMasterTrack([]);
        setSelectedDepartmentId("");
        setWorkCenterDay("");
        setWorkCenterIsActive(true);
        setSubmitted(false);
        setFormErrors({
            code: "Please enter code",
            name: "Please enter name",
            masterTrack: "Please select master track",
            department: "Please select department",
            day: "Please enter day",
        });
    };

    const deleteWorkCenter = async (value: boolean): Promise<void> => {
        if (!value) {
            return;
        }
        if (IsStringNullEmptyOrUndefined(isDeleteRecordId)) {
            return;
        }
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToDeleteWorkCenter(isDeleteRecordId);
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    toast.success(axiosResp.message, { ...toastOptObj, });
                    setIsDeleteRecordId("");
                    setFilterReq(prev => ({
                        ...prev,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }));
                }
            } else {
                toast.error(resp?.data?.message || "Unable to delete work centre", { ...toastOptObj, });
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    const actionIconTemplate = (rowData: WorkCenterDetailsEntity) => {
        return (
            <ul className="tableIcon cursor-pointer action-icon-template-w">
                {
                    checkActionAuthorization("update", "Work Center") && (
                        <li
                            data-toggle="tooltip"
                            title="Edit"
                        >
                            <img
                                src="assets/images/edit-icon.svg"
                                alt="Edit"
                                onClick={() => { handleEdit(rowData); }}
                            />
                        </li>
                    )
                }
                {
                    checkActionAuthorization("delete", "Work Center") && (
                        <li
                            data-toggle="tooltip"
                            title="Delete"
                            onClick={() => { setIsDeleteRecordId(rowData.id); }}
                        >
                            <DeleteConfirmationDialog isAccepted={deleteWorkCenter} />
                        </li>
                    )
                }

            </ul>
        );
    };

    const resetFilters = (): void => {
        setSelectedStatus("");
        setSelectedMasterFilters([]);
        setTempMasterFilters([]);
        setFilterReq(prev => ({
            ...prev,
            pageSize: 10,
            pageNumber: 0,
            sortColumn: "createdAt",
            sortOrder: "desc",
            codesearchText: "",
            fullNamesearchText: "",
            masterTracksearchIds: [],
            status: "",
            APICallCount:
                prev.APICallCount + 1,
        }));
    };

    const statusBodyTemplate = (
        rowData: WorkCenterDetailsEntity
    ) => {
        return (
            <span
                className={`badge badge-${rowData.isActive === true
                    ? "success"
                    : "danger"
                    }`}
            >
                {rowData.isActive
                    ? "Active"
                    : "Inactive"}
            </span>
        );
    };

    const codeFilterTemplate = () => {
        return (
            <InputText
                value={filterReq.codesearchText}
                placeholder="Search by code"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        codesearchText: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }))
                }
            />
        );
    };

    const fullNameFilterTemplate = () => {
        return (
            <InputText
                value={filterReq.fullNamesearchText}
                placeholder="Search by full name"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        fullNamesearchText: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }))
                }
            />
        );
    };

    const masterTrackFilterTemplate = () => {
        return (
            <MultiSelect
                ref={masterFilterRef}
                value={tempMasterFilters}
                options={masterTrackOptions}
                optionLabel="label"
                optionValue="value"
                placeholder="Select master track"
                className="p-column-filter"
                maxSelectedLabels={1}
                filter
                resetFilterOnHide
                panelFooterTemplate={() => (
                    <div className="p-2">
                        <button
                            type="button"
                            className="p-button p-component p-button-sm"
                            onClick={() => {
                                setSelectedMasterFilters(tempMasterFilters);

                                setFilterReq(prev => ({
                                    ...prev,
                                    masterTrackerIds: tempMasterFilters,
                                    pageNumber: 0,
                                    APICallCount: prev.APICallCount + 1,
                                }));

                                masterFilterRef.current.hide();
                            }}
                            disabled={
                                JSON.stringify([...tempMasterFilters].sort()) ===
                                JSON.stringify([...selectedMasterFilters].sort())
                            }
                        >
                            Apply
                        </button>
                    </div>
                )}
                onChange={(e) => {
                    setTempMasterFilters(e.value);
                }}
                onHide={() => {
                    setTempMasterFilters(selectedMasterFilters);
                }}
            />
        );
    };

    const statusRowFilterTemplate = (
        options: any
    ) => {
        return (
            <Dropdown
                value={selectedStatus}
                options={status}
                onChange={(e) => {
                    handleChangeStatus(
                        e.value
                    );
                }}
                placeholder="Select status"
                className="p-column-filter"
                style={{
                    minWidth: "12rem",
                }}
            />
        );
    };

    const handleChangeStatus = (
        e: string
    ) => {
        setSelectedStatus(e);

        setFilterReq(prev => ({
            ...prev,
            status:
                e === "Active"
                    ? "true"
                    : e === "Inactive"
                        ? "false"
                        : "",
            pageNumber: 0,
            APICallCount:
                prev.APICallCount + 1,
        }));
    };

    const handleChange = (
        fieldName: string,
        value: string
    ): void => {
        switch (fieldName) {
            case "code":
                setWorkCenterCode(value);

                setFormErrors(prev => ({
                    ...prev,
                    code: IsStringNullEmptyOrUndefined(value.trim())
                        ? "Please enter code"
                        : "",
                }));
                break;

            case "name":
                setWorkCenterName(value);

                setFormErrors(prev => ({
                    ...prev,
                    name: IsStringNullEmptyOrUndefined(value.trim())
                        ? "Please enter name"
                        : "",
                }));
                break;

            case "day":
                setWorkCenterDay(value);

                setFormErrors(prev => ({
                    ...prev,
                    day: IsStringNullEmptyOrUndefined(value.trim())
                        ? "Please enter day"
                        : "",
                }));
                break;
            default:
                break;
        }
    };


    const handleDepartmentChange = (value: string): void => {
        setSelectedDepartmentId(value);
        setFormErrors(prev => ({
            ...prev,
            department: IsStringNullEmptyOrUndefined(value) ? "Please select department" : "",
        }));
    };
    const handleSaveWorkCenter =
        async (): Promise<void> => {
            setSubmitted(true);
            const isValid = IsFormValid(formErrors);
            if (IsStringNullEmptyOrUndefined(workCenterCode.trim()) || IsStringNullEmptyOrUndefined(workCenterName.trim()) || (selectedMasterTrackId.length === 0) || IsStringNullEmptyOrUndefined(selectedDepartmentId) || IsStringNullEmptyOrUndefined(workCenterDay.trim())) {
                return;
            }
            if (!isValid) {
                return;
            }
            setIsLoading(true);
            let resp: AxiosResponse<APIResponseEntity>;
            try {
                if (isEditMode) {
                    resp = await APIToUpdateWorkCenter(
                        selectedWorkCenterId,
                        {
                            code: workCenterCode.trim(),
                            fullName: workCenterName.trim(),
                            masterTrackerId: selectedMasterTrackId,
                            departmentId: selectedDepartmentId,
                            day: Number(workCenterDay),
                            isActive: workCenterIsActive,
                            isDynamicJob: isDynamicJob,
                        }
                    );
                } else {
                    resp = await APIToCreateWorkCenter({
                        code: workCenterCode.trim(),
                        fullName: workCenterName.trim(),
                        masterTrackerId: selectedMasterTrackId,
                        departmentId: selectedDepartmentId,
                        day: Number(workCenterDay),
                        isDynamicJob: isDynamicJob,
                    });
                }
                if (resp && resp.data && (resp.status === 200 || resp.status === 201)) {
                    const axiosResp: APIResponseEntity = resp.data;
                    if (axiosResp && (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)) {
                        toast.success(axiosResp.message, { ...toastOptObj, });
                        closeWorkCenterDialog();
                        setFilterReq(prev => ({
                            ...prev, pageNumber: 0, APICallCount: prev.APICallCount + 1,
                        }));
                    }
                } else {
                    toast.error(resp?.data?.message, { ...toastOptObj, });
                }
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        };

    const fetchWorkCenterCsvDetails = async (): Promise<void> => {
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToExportWorkCenter();
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const excelUrl = axiosResp.data.xlsxUrl;
                    if (excelUrl && !IsStringNullEmptyOrUndefined(excelUrl)) {
                        const fileName: string = excelUrl.split("/").pop();
                        if (fileName && !IsStringNullEmptyOrUndefined(fileName)) {
                            await downloadCsvFile(excelUrl, fileName);
                        }
                    }
                }
            } else {
                toast.error(resp?.data?.message, { ...toastOptObj, });
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <>
            <Loader isLoading={isLoading} />
            <ConfirmDialog />
            <div className="content-wrapper">
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row align-items-center">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <h4 className="card-title mb-0">
                                                        Work Center
                                                    </h4>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">
                                                        {
                                                            checkActionAuthorization("create", "Work Center") && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-md font-weight-medium"
                                                                    onClick={handleAdd}
                                                                >
                                                                    Add Work Center
                                                                </button>
                                                            )
                                                        }
                                                        {
                                                            checkActionAuthorization("upgrade", "Allow to Export Work Center") && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-md font-weight-medium m-0 me-2"
                                                                    onClick={fetchWorkCenterCsvDetails}
                                                                >
                                                                    Export Work Center
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end mt-2">
                                                <span
                                                    className="resetFilters text-primary cursor-pointer"
                                                    onClick={resetFilters}
                                                >
                                                    Reset Filters
                                                </span>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col">
                                            <DataTable
                                                value={workCenterDetails}
                                                filterDisplay="row"
                                                scrollable
                                                sortField={filterReq.sortColumn}
                                                sortOrder={filterReq.sortOrder === "asce" ? 1 : -1}
                                                onSort={onTableSort}
                                                emptyMessage={"No work centres found"}
                                            >
                                                <Column
                                                    field="code"
                                                    header="CODE"
                                                    sortable
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={codeFilterTemplate}
                                                    style={{ minWidth: "200px", }}
                                                />
                                                <Column
                                                    field="fullName"
                                                    header="FULL NAME"
                                                    sortable
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={fullNameFilterTemplate}
                                                    style={{ minWidth: "280px", }}
                                                />
                                                <Column
                                                    field="masterTrackerCode"
                                                    header="MASTER TRACK"
                                                    body={(rowData) =>
                                                        Array.isArray(rowData.masterTrackerCode)
                                                            ? rowData.masterTrackerCode.join(", ")
                                                            : rowData.masterTrackerCode || ""
                                                    }
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={masterTrackFilterTemplate}
                                                    style={{ minWidth: "220px", }}
                                                />
                                                <Column
                                                    field="day"
                                                    header="DAY"
                                                    sortable
                                                    style={{ minWidth: "120px", }}
                                                />
                                                <Column
                                                    field="isActive"
                                                    header="STATUS"
                                                    sortable
                                                    body={statusBodyTemplate}
                                                    filter
                                                    filterField="isActive"
                                                    showFilterMenu={false}
                                                    filterElement={statusRowFilterTemplate}
                                                    style={{ minWidth: "220px", }}
                                                />
                                                <Column
                                                    field="createdAt"
                                                    header="Date Created"
                                                    sortable
                                                    body={(rowData: WorkCenterDetailsEntity) =>
                                                        rowData.createdAt
                                                            ? new Date(rowData.createdAt).toLocaleDateString("en-GB")
                                                            : "-"
                                                    }
                                                    style={{ minWidth: "200px" }}
                                                />
                                                {
                                                    (
                                                        checkActionAuthorization("update", "Work Center") || checkActionAuthorization("delete", "Work Center")) && (
                                                        <Column
                                                            header="Action"
                                                            body={actionIconTemplate}
                                                            style={{ minWidth: "220px", }}
                                                        />
                                                    )
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                    {
                                        !IsNullOrEmptyArray(workCenterDetails) && (
                                            <div className="mt-3">
                                                <PrimePaginator
                                                    onPageChange={onPageChange}
                                                    pageNumber={filterReq.pageNumber}
                                                    pageSize={filterReq.pageSize}
                                                    totalRecords={totalPageCount}
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                header={isEditMode ? "Edit Work Center" : "Add Work Center"}
                className="production-master-dialog"
                contentStyle={{ paddingBottom: "10px", }}
                resizable={false}
                draggable={false}
                visible={isWorkCenterDialogVisible}
                style={{ width: "450px", }}
                modal
                onHide={closeWorkCenterDialog}
                footer={<div className="d-flex justify-content-end gap-2">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={closeWorkCenterDialog}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSaveWorkCenter}
                    >
                        {isEditMode ? "Update" : "Save"}
                    </button>
                </div>
                }
            >
                <div className="row mt-3">
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                CODE{" "}
                                <sup className="mandatory">*</sup>
                            </label>
                            <InputText
                                id="workCenterCode"
                                value={workCenterCode}
                                maxLength={25}
                                className="form-control"
                                placeholder="Enter code"
                                onChange={(e) => handleChange("code", e.target.value)}
                            />
                            {submitted && (
                                <small className="text-danger font-weight-500">
                                    {formErrors.code}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                FULL NAME{" "}
                                <sup className="mandatory">*</sup>
                            </label>
                            <InputText
                                id="workCenterName"
                                value={workCenterName}
                                maxLength={25}
                                className="form-control"
                                placeholder="Enter full name"
                                onChange={(e) =>
                                    handleChange("name", e.target.value)}
                            />
                            {submitted && (
                                <small className="text-danger font-weight-500">
                                    {formErrors.name}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                MASTER TRACK{" "}
                                <sup className="mandatory">*</sup>
                            </label>
                            <MultiSelect
                                ref={masterTrackMultiSelectRef}
                                value={tempMasterTrack}
                                options={masterTrackOptions}
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Select master track"
                                className="w-100"
                                onChange={(e) => {
                                    setTempMasterTrack(e.value);
                                }}
                                maxSelectedLabels={1}
                                filter
                                resetFilterOnHide
                                panelFooterTemplate={() => (
                                    <div className="p-2">
                                        <button
                                            type="button"
                                            className="p-button p-component p-button-sm"
                                            onClick={() => {
                                                setSelectedMasterTrackId(tempMasterTrack);

                                                setFormErrors(prev => ({
                                                    ...prev,
                                                    masterTrack:
                                                        tempMasterTrack.length === 0
                                                            ? "Please select master track"
                                                            : "",
                                                }));

                                                masterTrackMultiSelectRef.current.hide();
                                            }}
                                            disabled={
                                                JSON.stringify([...tempMasterTrack].sort()) ===
                                                JSON.stringify([...selectedMasterTrackId].sort())
                                            }
                                        >
                                            Apply
                                        </button>
                                    </div>
                                )}
                                onHide={() => {
                                    setTempMasterTrack(selectedMasterTrackId);
                                }}
                            />
                            {submitted && (
                                <small className="text-danger font-weight-500">
                                    {formErrors.masterTrack}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                DEPT{" "}
                                <sup className="mandatory">*</sup>
                            </label>
                            <Dropdown
                                value={selectedDepartmentId}
                                options={departmentOptions}
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Select department"
                                className="w-100"
                                onChange={(e) => handleDepartmentChange(e.value)
                                }
                            />
                            {submitted && (
                                <small className="text-danger font-weight-500">
                                    {formErrors.department}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                DYNAMIC JOB{" "}
                                <sup className="mandatory">*</sup>
                            </label>
                            <Dropdown
                                value={isDynamicJob}
                                options={[
                                    {
                                        label: "Yes",
                                        value: true,
                                    },
                                    {
                                        label: "No",
                                        value: false,
                                    },
                                ]}
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Select"
                                className="w-100"
                                onChange={(e) => setIsDynamicJob(e.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                DAY{" "}
                                <sup className="mandatory">*</sup>
                            </label>
                            <InputText
                                id="workCenterDay"
                                value={workCenterDay}
                                keyfilter="pint"
                                className="form-control"
                                placeholder="Enter day"
                                onChange={(e) => handleChange("day", e.target.value)}
                            />
                            {submitted && (
                                <small className="text-danger font-weight-500">
                                    {formErrors.day}
                                </small>
                            )}
                        </div>
                    </div>
                    {isEditMode && (
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label>STATUS</label>

                                <div className="d-flex align-items-center mt-2">
                                    {Status.map(
                                        (option: any) => (
                                            <div
                                                key={option.code}
                                                className="d-flex align-items-center me-4"
                                            >
                                                <RadioButton
                                                    inputId={String(option.code)}
                                                    name="status"
                                                    className="me-2"
                                                    value={option.code}
                                                    onChange={(e) => setWorkCenterIsActive(e.value)}
                                                    checked={workCenterIsActive === option.code}
                                                />

                                                <label htmlFor={String(option.code)}>  {option.name}</label>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>
        </>
    );
}

export default WorkCenter;